export default "__VITE_ASSET__CS69ZSD9__"